import styles from './Education.module.scss';
import { useTranslation } from "react-i18next";

export default function Education() {
    const { t } = useTranslation();

    const educationItems = ['mit_java', 'mit_architecture', 'postgrad', 'bachelor'];

    return (
        <div id="Education" className={`${styles.education} container`}>
            <h1 className={styles.educationTitle}>{t("Education.title")}</h1>

            <div className={styles.educationGrid}>
                {educationItems.map((item) => (
                    <article key={item} className={styles.educationCard}>
                        <h3 className={styles.degree}>{t(`Education.${item}.degree`)}</h3>
                        <p className={styles.institution}>{t(`Education.${item}.institution`)}</p>
                        <p className={styles.period}>{t(`Education.${item}.period`)}</p>
                    </article>
                ))}
            </div>
        </div>
    );
}
